/**
 * Shared nav "active" logic for UserHeader + AuthHeader.
 * Uses path-prefix rules (not substring `includes`) to avoid false positives.
 */

export const HEADER_NAV_PLACEHOLDER_ROUTE = "/coming_soon";

/** Strip query/hash so `to` from React Router matches `location.pathname` only. */
export function navPathnameOnly(to) {
  if (to == null || typeof to !== "string") return "";
  const q = to.indexOf("?");
  const h = to.indexOf("#");
  const end = q === -1 ? (h === -1 ? to.length : h) : h === -1 ? q : Math.min(q, h);
  return to.slice(0, end);
}

/** True when this submenu `to` is the generic placeholder — must not mark "More" active for shared stubs. */
export function isMoreMenuPlaceholderDestination(to) {
  return navPathnameOnly(to) === HEADER_NAV_PLACEHOLDER_ROUTE;
}

/**
 * @param {string} pathname - `location.pathname`
 * @param {string} pathOrTo - nav base path or full `to` (query allowed; ignored for match)
 * @param {boolean} [exact=true]
 */
export function isNavPathActive(pathname, pathOrTo, exact = true) {
  const path = navPathnameOnly(pathOrTo);
  if (!path) return false;
  if (exact) return pathname === path;
  if (pathname === path) return true;
  if (path === "/") return pathname === "/";
  return pathname.startsWith(path.endsWith("/") ? path : `${path}/`);
}

/**
 * Checks if any item in a submenu array matches the current pathname.
 * Handles paths with appended parameters (like pairs /trade/BTC_USDT) by matching the base path.
 */
export function isAnySubmenuActive(pathname, submenuItems) {
  if (!submenuItems || !Array.isArray(submenuItems)) return false;
  
  return submenuItems.some((item) => {
    if (isMoreMenuPlaceholderDestination(item.to)) return false;
    
    // Extract base path (e.g. "/options" from "/options/BTC_USDT")
    const cleanTo = navPathnameOnly(item.to);
    const parts = cleanTo.split("/").filter(Boolean);
    if (parts.length === 0) return false;
    const basePath = "/" + parts[0];
    
    return isNavPathActive(pathname, basePath, false);
  });
}
